<template lang="pug">
div
    mixin fuel(fuel)
        div.row
            div.col-xs-5
                small {{ fuel.fuel.name }} (Pump {{ fuel.pump_id }})
            div.col-xs-2
                small.pull-right {{ fuel.price }}
            div.col-xs-5
                small.pull-right {{ fuel.amount }}

        div.row
            div.col-xs-5
                small {{ fuel.volume }} litre
            div.col-xs-2
                small.pull-right RM / L

    mixin product(product)
        div.row
            div.col-xs-5
                small {{ orderProductName(product) }}
            div.col-xs-2
                small.pull-right @{{ product.unit_price }}&nbsp;
            div.col-xs-2
                small.pull-right x{{ product.quantity }}
            div.col-xs-3
                small.pull-right {{ orderProductPrice(product) }}

    mixin discountProduct(product)
        div.row.grand-total-amount
            div(v-for="(discount, key) in product.discounts")
                div.col-xs-11.p-l-sm
                    small._500 {{ discount.name }}
                div.col-xs-1.p-r-sm(v-if="key === 0")
                    small.pull-right._500 x{{ discount.quantity }}

        div.row
            div.col-xs-5
                small {{ product.product.name }}
            div.col-xs-2
                small.pull-right @{{ afterDiscount(product) }}&nbsp;
            div.col-xs-2
                small.pull-right x{{ product.product.quantity }}
            div.col-xs-3
                small.pull-right {{ discountTotal(product) }}

        div.row
            div.col-xs-7
                small.pull-right (Discount @{{ product.applied_amount }})

        div.row
            div.col-xs-7
                small.pull-right (Normal Price: @{{ product.product.unit_price }})

    .row(v-if="cancelledOrderProducts.length")
        .col-xs-12
            small.dark.block.text-center.m-b-sm Cancelled Items

    div(v-for="product in cancelledOrderProducts")
        +product(product)

    .row(v-if="purchasedOrderProducts.length || orderProductDiscounts.length || purchasedOrderFuels.length")
        .col-xs-12
            small.dark.block.text-center.m-y-sm Purchased Item(s)

    div(v-for="fuel in purchasedOrderFuels")
        +fuel(fuel)

    div(v-for="product in orderProductDiscounts")
        +discountProduct(product)

    hr(v-if="orderDiscounts.length && purchasedOrderProducts.length")

    div(v-for="product in purchasedOrderProducts")
        +product(product)

    div.row(v-if="orderProducts.length")
        div.col-xs-12
            hr
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import StoreMixin from './store-mixin';
import { mapGetters } from 'vuex';

export default {
    mixins: [receiptMixin, StoreMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'hasTransaction',
            'isVoided',
            'outlet',
            'table',
            'orderTable',
            'orderProducts',
            'cashier',
            'cancelledOrderProducts',
            'purchasedOrderProducts',
            'orderDiscounts',
            'purchasedOrderFuels',
            'orderProductDiscounts',
        ]),
    },

    methods: {
        afterDiscount(product) {
            return (
                parseFloat(product.product.unit_price) -
                parseFloat(Math.abs(product.applied_amount))
            ).toFixed(2);
        },

        discountValue(discount) {
            return discount.value_type === 'PERCENTAGE'
                ? `${parseFloat(discount.value).toFixed()}%`
                : discount.value;
        },

        discountTotal(product) {
            return (
                product.product.unit_price * product.product.quantity +
                parseFloat(product.applied_amount)
            ).toFixed(2);
        },
    },
};
</script>

<style lang="scss" scoped>
.voided {
    font-size: 14px;
    vertical-align: middle;
}
.grand-total-amount {
    border: 1px solid #666;
    border-radius: 5px;
    margin-left: 0;
    margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/orders.vue